import React from "react";
import { Stack, Typography } from "@mui/material";

import { HoverInfo } from "../../components/inputs/HubButton/HoverInfo";
import { BarcodeStickers, HubIcon, UserDetailIcon } from "../../components";

import { StyledCard, StyledCardStack } from "./styles";
import BarcodeContextMenu from "../../pages/BarcodeBuilder/BarcodeContextMenu";

export const BarcodeCard = ({
  id,
  onClick = () => {},
  name,
  user,
  time,
  ...rest
}) => {
  return (
    <StyledCard>
      <StyledCardStack onClick={onClick}>
        <Stack direction="row" alignItems="center" gap="5px" padding="0px 1px">
          <HubIcon icon="Barcode" size={14} />
          <Typography variant="caption" fontWeight={500} textAlign="center">
            {name}
          </Typography>
        </Stack>
        <BarcodeStickers {...rest} />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          padding="0px 1px"
        >
          <Stack direction="row" alignItems="center" padding="0px 1px">
            <HoverInfo hoverTitle={user.name} hoverSubtitle={user.email}>
              <UserDetailIcon
                user={user}
                includeEmail={false}
                includeName={false}
                size={14}
              />
            </HoverInfo>
            <Typography variant="caption">Edited - {time}</Typography>
          </Stack>
          {/* <BarcodeContextMenu id={id} includeDownload={false} /> */}
        </Stack>
      </StyledCardStack>
    </StyledCard>
  );
};

export default BarcodeCard;
